import { Controller } from '@hotwired/stimulus'
import { renderStreamMessage } from '@hotwired/turbo'
import { patch, destroy } from '@rails/request.js'
import { showFlashMessage } from '../../helpers'
import { elementsByDataSlot, elementsForAdjacentWeeks, refreshTurboFrames } from '../../helpers/calendar/turbo_frames'

export default class extends Controller {
  static targets = ['updateForm', 'deleteForm']

  async handleExtendShrinkEvent(event) {
    event.preventDefault()

    const button = event.currentTarget
    const form = button.closest('form')
    const entryElement = document.querySelector(`[data-calendar-entry-id="${button.dataset.entryId}"]`)

    try {
      const response = await patch(form.action, {
        headers: {
          'Accept': 'application/json'
        },
        body: new FormData(form)
      })

      if (response.ok) {
        const data = await response.json
        if (data.html) {
          entryElement.outerHTML = data.html
        }

      } else {
        await this.handleErrorResponse(response, 'Failed to extend/shrink item. Please try again.')
      }
    } catch (error) {
      showFlashMessage('Network error. Please try again.')
    }
  }

  async handleDeleteEvent(event) {
    event.preventDefault()

    const button = event.currentTarget
    const form = button.closest('form')
    const entryElement = document.querySelector(`[data-calendar-entry-id="${button.dataset.entryId}"]`)

    const confirmed = await window.confirmationDialog("", form)

    if (!confirmed) {
      return
    }

    try {
      const response = await destroy(form.action, {
        headers: {
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        const slot = entryElement.closest('[data-calendar--sortable-target="slot"]')
        const sequenceId = slot.dataset.sequence
        const termId = slot.dataset.term
        const weekNumber = parseInt(slot.dataset.termWeek)

        entryElement.remove()

        const data = await response.json
        if (data.turbo_streams) {
          renderStreamMessage(data.turbo_streams)
        }

        refreshTurboFrames(elementsForAdjacentWeeks(sequenceId, termId, weekNumber))
      } else {
        await this.handleErrorResponse(response, 'Failed to remove item. Please try again.')
      }
    } catch (error) {
      showFlashMessage('Network error. Please try again.')
    }
  }

  async handleHideUnhideEvent(event) {
    event.preventDefault()

    const button = event.currentTarget
    const form = button.closest('form')
    const entryElement = document.querySelector(`[data-calendar-entry-id="${button.dataset.entryId}"]`)

    try {
      const response = await patch(form.action, {
        headers: {
          'Accept': 'application/json'
        },
        body: new FormData(form)
      })

      if (response.ok) {
        const data = await response.json
        if (data.html) {
          entryElement.outerHTML = data.html
        }

        const schedulableId = entryElement.dataset.schedulableId
        refreshTurboFrames(elementsByDataSlot('schedulable-id', schedulableId))
      } else {
        await this.handleErrorResponse(response, 'Failed to update visibility. Please try again.')
      }
    } catch (error) {
      showFlashMessage('Network error. Please try again.')
    }
  }

  async handleErrorResponse(response, defaultMessage) {
    try {
      const errorData = await response.json
      const errorMessage = errorData.errors?.join(', ') || defaultMessage
      showFlashMessage(errorMessage)
    } catch {
      showFlashMessage(defaultMessage)
    }
  }

}
